import { Menu, Transition } from '@headlessui/react';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import DeleteIcon from '../../assets/icons/delete.svg?react';

type AssistantMenuProps = {
  handleDeleteThread: VoidFunction;
};

export const AssistantMenu: FC<AssistantMenuProps> = ({ handleDeleteThread }) => {
  const { t } = useTranslation('assistant');

  return (
    <>
      <Menu as='div' className='self-end'>
        {({ open }) => (
          <>
            <Menu.Button className='flex gap-1'>
              {[...Array(3)].map((i) => (
                <span key={i} className='size-1.5 rounded-full bg-grey-400' />
              ))}
            </Menu.Button>
            <Transition
              show={open}
              as={Fragment}
              enter='transition ease-out duration-100'
              enterFrom='transform opacity-0 scale-95'
              enterTo='transform opacity-100 scale-100'
              leave='transition ease-in duration-75'
              leaveFrom='transform opacity-100 scale-100'
              leaveTo='transform opacity-0 scale-95'
            >
              <Menu.Items
                static
                className='origin-top-right absolute right-4 top-8 min-w-20 rounded-md shadow-lg bg-white-100 ring-1 ring-black ring-opacity-5 focus:outline-none z-50'
              >
                <Menu.Item>
                  {({ active }) => (
                    <button onClick={handleDeleteThread} className={twMerge('flex rounded-md items-center gap-2 px-3 py-2', active ? 'bg-gray-100' : '')}>
                      <DeleteIcon className='stroke-red-500' />
                      <p className='text-gray-700 text-sm first-letter:capitalize'>{t('startNewChat')}</p>
                    </button>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
    </>
  );
};
